import React, { useState, useContext, useEffect } from "react";
import "./conferenceSettings.css";
import "../../ui-styles/sliders/volumeSlider.css";

import RadioSelect from "../../lib/ui/radio/RadioSelect";
// import Checkbox from "../../lib/ui/checkbox/Checkbox";
import Button from "../../lib/ui/buttons/Button";
// import { Slider } from 'material-ui-slider';
import CamerasList from "./tools/camera";
import MicrophoneList from "./tools/microphone";
import { LangCtx } from "../../lib/context";
// import { useHistory, useParams } from 'react-router-dom';
import Loader from "../../lib/ui/loader/Loader";
import GuestJoin from "./components/GuestJoin";
import { getappointmentData } from "../../actions/appointment";
import PageCenterMsg from "../../lib/ui/pagecenter/pageCenterMsg";
import {API} from 'aws-amplify';




// const cameras = [{ label: "Default - Internal Microphone (Built-in)", value: "1" }, { label: "Internal Microphone (Built-in)", value: "2" }]
// function SoundMeter(context) {
//     console.log("context === ", context);
//     this.context = context;
//     this.instant = 0.0;
//     this.slow = 0.0;
//     this.clip = 0.0;
//     this.script = context.createScriptProcessor(2048, 1, 1);
//     const that = this;
//     this.script.onaudioprocess = function (event) {
//         const input = event.inputBuffer.getChannelData(0);
//         let i;
//         let sum = 0.0;
//         let clipcount = 0;
//         for (i = 0; i < input.length; ++i) {
//             sum += input[i] * input[i];
//             if (Math.abs(input[i]) > 0.99) {
//                 clipcount += 1;
//             }
//         }
//         that.instant = Math.sqrt(sum / input.length);
//         that.slow = 0.95 * that.slow + 0.05 * that.instant;
//         that.clip = clipcount / input.length;
//     };
// }

// SoundMeter.prototype.connectToSource = function (stream, callback) {
//     // console.log('SoundMeter connecting');
//     try {
//         this.mic = this.context.createMediaStreamSource(stream);
//         this.mic.connect(this.script);
//         // necessary to make sample run, but should not be.
//         this.script.connect(this.context.destination);
//         if (typeof callback !== 'undefined') {
//             callback(null);
//         }
//     } catch (e) {
//         console.error(e);
//         // console.log("SoundMeter Error", e)
//         if (typeof callback !== 'undefined') {
//             callback(e);
//         }
//     }
// }


// SoundMeter.prototype.stop = function () {
//     this.mic.disconnect();
//     this.script.disconnect();
// }

const ConferenceSettings = (props) => {
    const { l } = useContext(LangCtx);
    const {role, id, uid, history} = props;
    // const { role } = useContext(RoleCtx);
    // const { id, uid } = useParams();
    // const history = useHistory();

    const radioData = [{ id: 1, name: 'name', label: 'SIF - (320x240)' },
    { id: 2, name: 'name', label: 'VGA - (640x480)' },
    { id: 3, name: 'name', label: 'HD720p - (1280x720)' },
    { id: 4, name: 'name', label: 'HD1080p - (1920x1080)' },
    { id: 5, name: 'name', label: '2K - (2048×1080)' }
    // { id: 6, name: 'name', label: '4K - (3840 x 2160)' },
    ];

    const [checkedValue, setIsChecked] = useState(localStorage.getItem('resolution') || 2);
    const [deviceList, setDeviceList] = useState([]);
    const [avError, setAVError] = useState({ status: false, message: "" });
    const [camId, setCamId] = useState(localStorage.getItem('camera') || '');
    const [micId, setMicId] = useState(localStorage.getItem('mic') || '');
    const [audioOnly, setAudioOnly] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openGuestPage, setopenGuestPage] = useState(false)
    const [data, setAppointment] = useState(null);
    // let audioContext = null;
    const [guest_data, setGusetData] = useState({ name: '', email: '' });
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        setLoading(true);
        // sessionStorage.reload = true;
        fetchDevices(true, true).then(res => {
            setDeviceList(res);
            setLoading(false);
        }).catch(err => {
            setAudioOnly(true);
            fetchDevices(false, true).then(response => {
                setDeviceList(response);
                setLoading(false);
            });
        })
        getappointmentData(id).then(res => {
            setLoading(false);
            if (res.status && res.data) {
                let now = new Date().valueOf();
                let st = new Date(res.data.startTime);
                st.setMinutes(st.getMinutes() - 30);
                if (st.valueOf() > now) {
                    setErrorMsg(l.Plz_join_at_sch_time);
                } else if (now > res.data.endTime) {
                    setErrorMsg(l.link_expired);
                } else {
                    setErrorMsg('');
                    setAppointment(res.data);
                }
            } else {
                history.push("/");
            }
        }).catch(err => {
            console.log("err ==== ", err);
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
            history.push("/");
        })
        // try {
        //     window.AudioContext = window.AudioContext || window.webkitAudioContext;
        //     audioContext = new window.AudioContext();
        //     audioContext.resume();
        // } catch (error) {
        //     // this.setState({ isWebAudioSupported: false });
        // }
        return () => {
            if (window.stream) {
                window.stream.getTracks().forEach(track => {
                    track.stop();
                });
                window.stream = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!role || role === "") {
            setopenGuestPage(true);
        }
    }, [role])

    useEffect(() => {
        if (camId !== "") {
            renderVideoAudioDevice(true);
            localStorage.setItem('camera', camId);
        } else {
            localStorage.removeItem('camera');
        }
    }, [camId]);

    useEffect(() => {
        if (micId !== '') {
            localStorage.setItem('mic', micId);
            if (audioOnly) {
                renderVideoAudioDevice(false);
            }
        } else {
            localStorage.removeItem('mic');
        }
    }, [micId])

    const fetchDevices = async (videoStats = true, audioStats = true) => {
        try {
            
            const media = await navigator.mediaDevices.getUserMedia({ video: videoStats, audio: audioStats });
            if (media) {
                media.getTracks().forEach(track => {
                    track.stop();
                })
            }       

            return navigator.mediaDevices.enumerateDevices().then(function (devices) { return devices; });
            // }).catch(handleError);

            
            // console.log('Media ', media);
        } catch (err) {
            console.log("err === ", err);
        }
    }

    const handleError = (error) => {
        console.log('Handle Error', error, )
        setAVError({ status: true, message: l.dev_error });
        return null;
    }

    const updateDeviceId = (type, deviceId, play = true) => {
        switch (type) {
            case 'camera':
                // console.log("deviceId === ", deviceId);
                setCamId(deviceId);
                break;
            case 'mic':
                // console.log('Mic fried', );
                // this.setState({ microphoneDeviceId: deviceId }, function () {
                //     if (this.state.meetingInfoItem.audioOnly || this.state.audioOnlyLoaded) {
                //         this.renderVideoAudioDevice(false);
                //     }
                // })
                setMicId(deviceId);
                break;
            case 'speaker':
                // this.setState({ speakerDeviceId: deviceId }, function () {
                //     this.renderSpeakerDevice(deviceId, play);
                // });
                break;
            default:
                // this.setState({ cameraDeviceId: '', microphoneDeviceId: '', speakerDeviceId: '' })
                setCamId('');
                setMicId('');
                break;
        }
    }

    const renderVideoAudioDevice = (isVideo) => {
        if (window.stream) {
            window.stream.getTracks().forEach(track => {
                track.stop();
                // console.log('Track Stopped') 
            });
        }

        let constraints = {
            audio: { deviceId: micId && micId !== '' ? { exact: micId } : undefined },
            video: { deviceId: camId && camId !== '' ? { exact: camId } : undefined }
        };

        if (audioOnly) {
            constraints = {
                audio: { deviceId: micId && micId !== "" ? { exact: micId } : undefined }
            }
        }
        // console.log('Before getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then(gotStream).catch(handleError);
    }

    const gotStream = (stream) => {
        window.stream = stream;
        // console.log('Got Stream', stream);

        if (!audioOnly) {
            // this.setState({ audioVideoError: false, cameraNotLoaded: false });

            let videoBox = document.getElementById('videoBox');
            if (videoBox) {
                videoBox.srcObject = stream;
            }
        }
        // if (audioContext !== null) {
        //     const soundMeter = new SoundMeter(audioContext);
        //     let instantMeter = document.getElementById('audioMeter');
        //     soundMeter.connectToSource(stream, (e) => {
        //         if (e) {
        //             alert(e);
        //             return;
        //         }
        //         window.audiointerval = setInterval(() => {
        //             instantMeter.value = soundMeter.instant.toFixed(2);
        //         }, 200);
        //     });
        //     audioContext.resume();
        // }
    }

    const handleCancel = () => {
        history.push(`/`);
    }

    const handleRes = (val) => {
        localStorage.setItem("resolution", val);
        setIsChecked(val)
    }

    // const handleSound = (event, newValue) => {
    //     localStorage.setItem("sound", newValue)
    //     setSound(newValue);
    // }

    const handleJoin = () => {
        if (!errorMsg || (errorMsg && errorMsg === '')) {
            // role === "D" ? history.push(`/doctor-conference/${id}/${uid}`) : (role === "C" || role === "P") ?
            //     history.push(`/waiting-room/${id}`)
            //     : history.push(`/guest-conference/${id}?name=${guest_data.name}&email=${guest_data.email}`)
            // role === "C" ? history.push(`/patient-waiting-room/${id}`) : history.push(`/waiting-room/${id}`);
            if (role === "D") {
                history.push(`/doctor-conference/${id}/${uid}`);
            } else if (role === "C") {
                history.push(`/patient-waiting-room/${id}`);
            } else if (role === "P") {
                history.push(`/waiting-room/${id}`);
            } else {
                history.push(`/guest-conference/${id}?name=${guest_data.name}&email=${guest_data.email}`); 
            }
        } else {
            history.push("/");
        }
    }

    const saveGuest = (g_name, g_email) => {
        setopenGuestPage(false);
        setGusetData({ name: g_name, email: g_email });
    }

    const handleClose = () => {
        history.push("/");
        // window.location.reload();
    }

    return (
        <div className="confstngCntnr">
            {loading && <Loader />}
            {errorMsg && errorMsg !== '' && <PageCenterMsg src="/images/icons/session-expired.png" Heading="Appointment" label={errorMsg} btnAction={true} btnlabel={l.okay} handleButton={handleClose} />}
            <div className="confinnerCntnr">
                <div className="csRow pd16">
                    {data && <p className="pTxt">{l.conf_set_desc} <span className="txtBold">{role === "D" ? data["patientData"].firstName : `Dr. ${data["doctorData"].firstName}`}</span>,{l.conf_set_desc_more}</p>}
                </div>
                <div className="videoInputBlock">
                    <div className="videoCntnr">
                        <div className="videoDisplay">
                            <video loop="" className="mediaFile" id="videoBox" muted autoPlay playsInline />
                            {/* <div className="mirrorBtn">
                                <span>{l.mirr_vid}</span>
                            </div> */}
                            {/* <div className={mute ? "imgTglBtn handleMute" : "imgTglBtn"} onClick={() => setMute(prevState => !prevState)}>
                                <img src="/images/icons/video-cam.png" className="invertWhite imgIcon" alt="icon" />
                            </div> */}
                        </div>
                    </div>
                    <div className="deviceCntnr">
                        <div className="inputCntnr">
                            <div className="inputIcon">
                                <img src="/images/icons/webcam.png" className="icnImg invertGray" alt="icon" />
                            </div>
                            <div className="inputBox">
                                <CamerasList deviceList={deviceList} deviceHandle={updateDeviceId} handleError={handleError} />
                            </div>
                        </div>
                        <div className="inputCntnr">
                            <div className="inputIcon">
                                <img src="/images/icons/microphone.png" className="icnImg invertGray" alt="icon" />
                            </div>
                            <div className="inputBox">
                                <MicrophoneList deviceList={deviceList} deviceHandle={updateDeviceId} handleError={handleError} />
                            </div>
                        </div>
                        {/* <div className="inputCntnr">
                            <div className="meterCntnr">
                                <div className="meterBlock">
                                    <meter id="audioMeter" high="0.2" max="1" value="0"></meter>
                                    <div className="overBar">
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                        <span className="pid"></span>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/*<div className="inputCntnr">
                            <div className="inputIcon">
                                <img src="/images/icons/volume.png" className="icnImg invertGray" alt="icon" />
                            </div>
                            <Slider value={sound} min={0} max={100} step={1} aria-labelledby="label"></Slider>
                             <div className="inputBox">
                                <div class="volume">
                                    <input type="range" min="0" max="100" step="1" value="100" id="np-volume" class="volumeSlider" role="progressbar" />
                                </div>
                            </div> 
                        </div>*/}
                    </div>
                </div>

                <div className="videoResBlock">
                    <div className="csRow pd16">
                        <span className="subHdngTxt">{l.sel_res}</span>
                    </div>
                    <div className="slectRdGroup pdZero12">
                        <form className="slectRdWrapper">
                            {radioData.map(item => (
                                <div className="slectRdItem" key={item.id}>
                                    <div className="rdCntnr">
                                        <div className="inputGroup">
                                            <RadioSelect
                                                id={item.id}
                                                name="resolution"
                                                type="radio"
                                                label={item.label}
                                                checked={checkedValue === item.id}
                                                onChange={() => handleRes(item.id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </form>
                    </div>
                    {/* <div className="csRow pd16">
                        <div className="rprtBox">
                            <Checkbox
                                onClick={(e) => setValue(e.target.checked)}
                                type="checkbox"
                                id="check"
                                name="confirm"
                                value=""
                                for="check"
                                checked={checked ? true : false}
                            />
                            <p>{l.conf_set_check}</p>
                        </div>
                    </div> */}
                    <div className="csRow pdZero16">
                        <p className="pTxtSm">{l.conf_troubleshoot} <a href="https://connect.instavc.com/troubleshoot" target="_blank" rel="noopener noreferrer" className="anchorTxt">{l.conf_set_trouble}</a></p>
                    </div>
                </div>

                <div className="btmFtrBlock">
                    <div className="btmBtnGropu">
                        <Button
                            size="md"
                            type="outLine"
                            label={l.cancel}
                            onClick={handleCancel}

                        />
                        {!loading && deviceList && deviceList.length > 0 && <Button
                            size="md"
                            type="primary"
                            label={l.join_mtng}
                            onClick={handleJoin}

                        />}
                    </div>
                </div>
            </div>
            {openGuestPage && <GuestJoin openGuestInfo={openGuestPage} handleSave={saveGuest} />}
        </div>
    )
}
export default ConferenceSettings;

